import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['list', 'option', 'label']
  static values = { current: { type: String, default: 'newest' } }

  connect () {
    this.sort()
  }

  select (event) {
    event.preventDefault()
    const value = event.currentTarget.dataset.sortValue
    if (!value) return
    this.currentValue = value
    this.sort()
  }

  sort () {
    if (!this.hasListTarget) return
    const items = Array.from(this.listTarget.querySelectorAll('[data-sort-id]'))

    items.sort((a, b) => {
      switch (this.currentValue) {
        case 'oldest':
          return Number(a.dataset.sortId) - Number(b.dataset.sortId)
        case 'alphabetical':
          return (a.dataset.sortTitle || '').localeCompare(b.dataset.sortTitle || '')
        case 'inactive': {
          const aInactive = Number(a.dataset.sortInactive || 0)
          const bInactive = Number(b.dataset.sortInactive || 0)
          if (aInactive !== bInactive) return bInactive - aInactive
          return Number(b.dataset.sortDays || 0) - Number(a.dataset.sortDays || 0)
        }
        case 'most_completed':
          return Number(b.dataset.sortCount || 0) - Number(a.dataset.sortCount || 0)
        case 'newest':
        default:
          return Number(b.dataset.sortId) - Number(a.dataset.sortId)
      }
    })

    items.forEach((item) => this.listTarget.appendChild(item))

    if (this.hasOptionTarget) {
      this.optionTargets.forEach((opt) => {
        const isSelected = opt.dataset.sortValue === this.currentValue
        opt.dataset.selected = isSelected.toString()
        opt.classList.toggle('bg-gray-50', isSelected)
        opt.classList.toggle('font-bold', isSelected)
        const check = opt.querySelector('[data-check]')
        if (check) check.classList.toggle('hidden', !isSelected)
      })
    }

    if (this.hasLabelTarget) {
      const active = this.optionTargets.find((opt) => opt.dataset.sortValue === this.currentValue)
      if (active) this.labelTarget.textContent = active.dataset.sortLabel || active.textContent.trim()
    }
  }
}
